"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAwardById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Retrieve an award with given ID (if it exists).
 * If requested award has children they will get returned with it.
 *
 * Award is identified by its stringified `ObjectID`.
 *
 * ## Usage
 *
 * ```ts
 * const awardId: string = "5f5e555d5a578b6";
 * const award: Award = await sdk.getAwardById({ awardId });
 * ```
 *
 * @param params.awardId - ID of the award to fetch.
 */
const getAwardById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { awardId } = params;
    const url = `${BASE_URL}/awards/award/${awardId}`;
    const awardResponse = yield axios_1.default.get(url, { validateStatus: () => true });
    const { status, data } = awardResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getAwardById = getAwardById;
